import React from 'react';
import Header from '../../components/layout/Header';
import ReportCatalog from '../../components/reports/ReportCatalog';

export default function BrandReports() {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Header title="Reports" subtitle="Available reports for your engagements" />
      <div className="flex-1 overflow-y-auto p-6">
        <ReportCatalog />
      </div>
    </div>
  );
}
